<template>
	<div id="rewardlist">
		<div class="page">
		  <div class="rewardbox" v-for="item in rewardList">
			<div class="tit">
			  {{item.markersubject}}
			  <span>{{item.markersetsubject}}</span>
			</div>
			<div class="detail">
			  <div class="price">￥{{item.price}}</div>
			  <div class="time">{{item.create_at}}</div>
			</div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Rewardlist',
	data () {
		return {
			rewardList:[]
		}
	},
	created (){
		this.$https.post('/api/marker/rewardlist',this.$qs.stringify({
			token:this.$store.state.token,
			marker_id:this.$route.query.id
		})).then((res) => {
			this.rewardList = res.data.data.rewardList
		}).catch((res) => {
			console.log('请求失败');
		})
	},
	methods : {
	}
}
</script>
<style scoped>
	#rewardlist{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.rewardbox{
	  border-bottom:1px solid #EEEEEE;
	  border-radius:1vw;
	  font-size:3.7vw;
	  color:#000000;
	  padding:4vw 3vw;
	}
	.rewardbox .tit{
	  line-height:7vw;
	  font-size:4.2vw;
	}
	.rewardbox .tit span{
	  float:right;
	  font-size:3.7vw;
	  color:#a2a2a2;
	}
	.rewardbox .detail{
	  display:flex;
	  margin-top:2vw;
	  display:-webkit-flex;
	}
	.rewardbox .detail > div{
	  flex:1;
	}
	.rewardbox .detail > div.time{
	  text-align:right;
	  color:#A2A2A2;
	}
	.rewardbox .detail > div.price{
	  text-align:left;
	  color:coral;
	  font-size:5.2vw;
	  font-weight:bold;
	}
</style>


// WEBPACK FOOTER //
// src/components/Rewardlist.vue